import {createStore, compose, applyMiddleware} from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { createHashHistory as createHistory } from 'history';
// 'routerMiddleware': the new way of storing route changes with redux middleware since rrV4.
import { routerMiddleware } from 'connected-react-router';
import createRootReducer from '../reducers';
import {DO_LOGOUT, DO_VERIFY_ACCOUNT_SUCCESS} from "../constants/actionTypes";
import {createStateSyncMiddleware, initMessageListener} from "redux-state-sync";

export const history = createHistory();

const reactStateSyncConfig = {
  // TOGGLE_TODO will not be triggered in other tabs
  whitelist: [DO_VERIFY_ACCOUNT_SUCCESS],
};

function configureStoreProd(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const middlewares = [
    // Add other middleware on this line...
    createStateSyncMiddleware(reactStateSyncConfig),

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/reduxjs/redux-thunk#injecting-a-custom-argument
    thunk,
    reactRouterMiddleware,
  ];

  const store = createStore(
    createRootReducer(history),
    initialState,
    compose(
      applyMiddleware(
        routerMiddleware(history),
        ...middlewares
      )
    )
  );
  initMessageListener(store);
  return store;
}

function configureStoreDev(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const middlewares = [
    // Add other middleware on this line...
    createStateSyncMiddleware(reactStateSyncConfig),

    // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
    reduxImmutableStateInvariant({
      ignore: [
        'registration.data.recordImageFile',
        'registration.data.imageFile',
        'admin.profile.data.recordImageFile',
        'admin.profile.data.imageFile',
        'admin.gifts.gift.data.imageFile',
        'admin.gifts.gift.data.imageFileAr',
        'admin.gifts.gift.data.imageFile',
        'admin.employeeChats.employeeChat.data.imageFile',
        'admin.employeeChats.employeeChat.data.audioFile',
        'admin.customerChats.customerChat.data.imageFile',
        'admin.customerChats.customerChat.data.audioFile',
        'admin.posts.post.data.imageFile',
        'admin.posts.post.data.audioFile',
        'admin.activities.activity.data.imageFile',
        'admin.activities.activity.data.imageFileAr',
        'admin.activities.activity.data.audioFile',
        'admin.activities.activity.data.audioFileAr',
      ]
    }),

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/reduxjs/redux-thunk#injecting-a-custom-argument
    thunk,
    reactRouterMiddleware,
  ];

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
  const store = createStore(
    createRootReducer(history),
    initialState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history),
        ...middlewares
      )
    )
  );
  initMessageListener(store);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer(history));
    });
  }

  return store;
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
